import alt from 'components/Dispatcher';
import BusinessSource from 'sources/BusinessSource';
import BusinessActions from 'actions/BusinessActions';

export class BusinessStore {
  constructor() {
    this.state = {
      business: {},
      postBusiness: {},
      businessList: [],
      articles: [],
      user_id: '',
      id: '',
      first: 0,
      maxCount: 20,
      accessToken: null,
      loading: false,
      articlesLoading: false,
      hasMore: true,
      articlesMore: true,
      offset: 0
    };
    this.registerAsync(BusinessSource);
    this.bindListeners({
      handleFetchBusiness: BusinessActions.FETCH_BUSINESS,
      handleUpdateBusiness: BusinessActions.UPDATE_BUSINESS,
      handleUpdateBusinessList: BusinessActions.UPDATE_BUSINESS_LIST,
      handleUpdateAllBusinessList: BusinessActions.UPDATE_ALL_BUSINESS_LIST,
      handleFetchBusinessList: BusinessActions.FETCH_BUSINESS_LIST,
      handleSetLoading: BusinessActions.SET_LOADING,
      handleUpdateBusinessOffset: BusinessActions.UPDATE_BUSINESS_OFFSET,
      handleClearBusiness: BusinessActions.CLEAR_BUSINESS,
      handleUpdateArticles: BusinessActions.UPDATE_ARTICLES,
      handleFetchArticles: BusinessActions.FETCH_ARTICLES,
      handleClearArticles: BusinessActions.CLEAR_ARTICLES,
      handlePostBusiness: BusinessActions.POST_BUSINESS
    });
  }
  handlePostBusiness(business){
    this.state.postBusiness = business
    this.getInstance().postRemoteBusiness()
  }
  // 设置 loading 状态
  handleSetLoading(loading) {
    this.setState({loading: loading});
  }
  // 根据 business_id 获取 business 详情
  handleFetchBusiness(id) {
    this.state.id = id;
    this.getInstance().getRemoteBusiness();
  }
  handleClearBusiness() {
    this.setState({business:{},businessList:[]});
  }
  handleClearArticles() {
    this.setState({articles: []})
  }
  handleUpdateBusinessOffset(offset){
    this.setState({offset:offset});
  }
  // 保存 BusinessList 详情
  handleUpdateBusiness(business) {
    this.setState({business: business});
  }
  // 发请求追加 BusinessList
  handleFetchBusinessList(id) {
    let first = this.state.businessList.length ? this.state.businessList.length + 1 : 0;
    this.setState({user_id:id, first: first, loading: true});
    this.getInstance().getRemoteBusinessList();
  }
  // 追加 BusinessList 新的数据
  handleUpdateBusinessList(businessList) {
    let more = businessList.length === this.state.maxCount;
    let list = this.state.businessList.concat(businessList);
    this.setState({businessList: list, loading: false, hasMore: more});
  }
  // 更新全部 BusinessList
  handleUpdateAllBusinessList(businessList) {
    this.setState({businessList: businessList});
  }
  handleUpdateArticles(articles){
    let more = articles.length === this.state.maxCount;
    let list = this.state.articles.concat(articles);
    this.setState({articles: list, articlesLoading: false, articlesMore: more});
  }
  handleFetchArticles(id){
    this.state.id = id
    let first = this.state.articles.length ? this.state.articles.length + 1 : 0;
    this.setState({first: first, articlesLoading: true});
    this.getInstance().getRemoteArticles();
  }
}

export default alt.createStore(BusinessStore, 'BusinessStore');


// WEBPACK FOOTER //
// ./src/stores/BusinessStore.js